import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Calendar: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[1.5px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2.00024V5.00024M16 2.00024V5.00024M3.5 9.09024H20.5M21 8.50024V17.0002C21 20.0002 19.5 22.0002 16 22.0002H8C4.5 22.0002 3 20.0002 3 17.0002V8.50024C3 5.50024 4.5 3.50024 8 3.50024H16C19.5 3.50024 21 5.50024 21 8.50024Z"
      stroke="currentColor"
      strokeWidth="currentStrokeWidth"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6949 13.7002H15.7039M15.6949 16.7002H15.7039M11.9949 13.7002H12.0049M11.9949 16.7002H12.0049M8.29395 13.7002H8.30395M8.29395 16.7002H8.30395"
      stroke="currentColor"
      strokeWidth="currentStrokeWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Calendar;
